import process from "process";

const development: boolean = !process.env.NODE_ENV
    || process.env.NODE_ENV === 'development'
    || (typeof (window) !== "undefined"
        && window.location.host.includes("test.learnsic"))

export default function isDev(): boolean {
    return development;
}